var _path, _path2, _path3, _rect, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrownShadow = function SvgCrownShadow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5761 29.7173L79.2392 44.8477H55.9131L67.5761 29.7173Z",
    fill: "url(#paint0_linear_1080_5898)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8584 29.7173L39.5214 44.8477H16.1953L27.8584 29.7173Z",
    fill: "url(#paint1_linear_1080_5898)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0225 68.5968L8 19L27.8587 44.6962L47.7174 19L67.5761 44.6962L87.4348 19L79.4122 68.5968C78.6288 73.4403 74.447 77 69.5405 77H25.8942C20.9877 77 16.806 73.4403 16.0225 68.5968Z",
    fill: "url(#paint2_linear_1080_5898)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.043,
    y: 69.4023,
    width: 69.3478,
    height: 7.59842,
    rx: 3.79921,
    fill: "url(#paint3_linear_1080_5898)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 47.5,
    cy: 86.5,
    rx: 34.5,
    ry: 2.5,
    fill: "url(#paint4_linear_1080_5898)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1080_5898",
    x1: 67.7276,
    y1: 29.7173,
    x2: 78.088,
    y2: 47.5176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1080_5898",
    x1: 28.0098,
    y1: 29.7173,
    x2: 38.3702,
    y2: 47.5176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1080_5898",
    x1: 47.4357,
    y1: 28.7137,
    x2: 48.1686,
    y2: 70.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBE9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1080_5898",
    x1: 47.7169,
    y1: 77.0008,
    x2: 48.1789,
    y2: 69.4305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1080_5898",
    x1: 89.8409,
    y1: 84.3333,
    x2: 86.9443,
    y2: 102.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF8FF",
    stopOpacity: 0.3
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrownShadow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "crown-shadow.d908fa999d08aeccadcacbf6a47f6a04.svg";